import { render, staticRenderFns } from "./View12.vue?vue&type=template&id=67e6a68a&scoped=true&"
import script from "./View12.vue?vue&type=script&lang=js&"
export * from "./View12.vue?vue&type=script&lang=js&"
import style0 from "./View12.vue?vue&type=style&index=0&id=67e6a68a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e6a68a",
  null
  
)

export default component.exports